import React from "react";

const GridIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill={props.fill}><path d="M22.026 14.163l-5.126 4.837a.8.8 0 0 1-.753.208.749.749 0 0 1-.555-.524.7.7 0 0 1 .221-.71l3.815-3.6h-13.528a.727.727 0 1 1 0-1.451h15.382a.771.771 0 0 1 .71.448.7.7 0 0 1-.166.79zm-2.851-5.35a.748.748 0 0 0-.769-.726h-13.529l3.815-3.6a.7.7 0 0 0 .221-.71.749.749 0 0 0-.555-.524.8.8 0 0 0-.753.208l-5.129 4.839a.7.7 0 0 0-.166.79.771.771 0 0 0 .71.448h15.38a.748.748 0 0 0 .769-.726z" transform="translate(-2.251 -3.231)"/></svg>
    )
}

export default GridIcon;